export const navigation = [   
  {
    name: 'Dashboard',
    url: '/dashboard',
    icon: 'fa-drivers-license-o '
  }, 
  {
    title: true,
    name: 'License Management',
    wrapper: {
      element: 'span'
    },
    class: 'text-center'
  },
  {
    name: 'Licenses',
    url: '/licenses',
    icon: 'fa-drivers-license-o '
  },
  {
    name: 'Customers',
    url: '/customers',
    icon: 'icon-people'
  },
  {
    name: 'Features',
    url: '/features',
    icon: 'icon-layers'
  },
  {
    name: 'Change Logs',
    url: '/changelogs',
    icon: 'icon-layers'
  },
  {
    title: true,
    name: 'Cloud Management',
    wrapper: {
      element: 'span'
    },
    class: 'text-center'
  },
  {
    name: 'Reset Cloud Password',
    url: '/resetcloudpassword',
    icon: 'icon-layers'
  },
  // {
  //   name: 'Login',
  //   url: '/login',
  //   icon: 'icon-pencil'
  // },
  // {
  //   name: 'Register',
  //   url: '/register',
  //   icon: 'icon-pencil'
  // },
  {
    title: true,
    name: 'Other',
    wrapper: {
      element: 'span'
    },
    class: 'text-center'
  },
  {
    name: 'Logout',
    url: '/logout',
    icon: 'icon-drop'
  },
];



// WEBPACK FOOTER //
// ./src/app/_nav.ts